import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Grid, CardHeader, TextField, Typography, alpha, lighten, Card, CardContent, Button, useTheme } from '@mui/material';
import Styles from '../../theme/commonCss/Styles';
import FormModal from '../../common/formModal';
import { isTypeNode } from 'typescript';
import { get } from 'lodash';
import { useState } from 'react';
import AjvErrors from 'ajv-errors';
import Ajv from 'ajv';
import { thmeShema } from './form';
import { useDispatch } from 'react-redux';
import { settingsActions } from '../../store/reducers/settings';
import { SketchPicker } from 'react-color';
import Modal from '../../common/Modal';
import { useOutletContext } from 'react-router-dom';

const styles = {
  modalWrapper: { display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'red' },
  gridContainer: {
    width: '100%',
  },
  colorBoxWrapper: {
    boxSizing: 'borderBox',
    display: 'flex',
    justifyContent: 'center'
  },
};

const EditSetting = ({
  isOpen,
  handleClose = () => { },
  pageSettings,
  setPageSettings,
  selectedTheme
}: any) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {})
  const [selectedColor, setSelectedColor] = useState<any>(pageSettings[selectedTheme])
  const handleColorChange = (color: any) => {
    setSelectedColor(color.hex)    
  }

  var inputStyles: any = {
    input: {
      border: 'none',
      boxShadow: 'none'
    },
    label: {
      fontSize: '18px',
      color: '#999',
    },
  };

  const handleColorPopup = ()=>{    
    setPageSettings({ ...pageSettings, [selectedTheme]: selectedColor })
    handleClose();
  }

  return (
    <Modal
      title={selectedTheme.replace('_', ' ')}
      open={isOpen}
      handleClose={handleClose}
      dialogContentStyles={Styles.masterContainer}
      customStyles={{
        maxHeight: '60vh',
        maxWidth: '300px',
        textTransform: 'capitalize'
      }}
    >
      <Card sx={{ ...Styles.card, backgroundColor: '#FFFFFF' }}>
        <CardContent sx={{ ...Styles.cardContent, backgroundColor: 'transparent' }}>
          <SketchPicker styles={{
            default: {
              picker: {               
                padding: "0",
                borderRadius: "0",
                boxShadow:'none'
              }
            }
          }} width='auto' color={selectedColor} onChange={(color: any) => { handleColorChange(color) }} />
          <Grid container sx={{ marginTop: '32px' }}>
            <Grid xs={12} textAlign={'center'}>
              <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={handleClose}>
                Cancel
              </Button>
              <Button variant='contained' type='submit' sx={{ width: '100px' }} onClick={handleColorPopup} >
                Ok
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default EditSetting;